import { render, staticRenderFns } from "./MenusFormComponent.vue?vue&type=template&id=c3e7ab40&scoped=true&"
import script from "./MenusFormComponent.vue?vue&type=script&lang=js&"
export * from "./MenusFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenusFormComponent.vue?vue&type=style&index=0&id=c3e7ab40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e7ab40",
  null
  
)

export default component.exports